<div class="ds-login-bg">
  <!-- Radial gradient overlay (decorative) -->
  <div class="ds-login-gradient" aria-hidden="true"></div>

  <div class="ds-login-wrap">

    <!-- Brand — above card -->
    <div class="ds-login-brand">
      <div class="ds-login-logo" aria-label="RARR brand logo">
        <span class="ds-login-logo-letter">R</span>
      </div>
      <h1 class="ds-login-title">RARR Platform</h1>
      <p class="ds-login-subtitle">Secure access portal</p>
    </div>

    <!-- Card -->
    <div class="ds-login-card">

      <!-- Card header -->
      <div class="ds-login-card-header">
        <h2 class="ds-login-card-title">Sign in to your account</h2>
        <p class="ds-login-card-desc">Use your RARR credentials to continue.</p>
      </div>

      <!-- Card body -->
      <div class="ds-login-card-body">

        <!-- Inline error alert -->
        @if (loginError()) {
          <div class="ds-login-alert" role="alert">
            <i class="bi bi-exclamation-triangle ds-login-alert-icon" aria-hidden="true"></i>
            <span>{{ loginError() }}</span>
          </div>
        }

        <!-- Form -->
        <form (ngSubmit)="onLogin()" #loginForm="ngForm" novalidate>

          <!-- Username -->
          <div class="ds-field">
            <label for="username" class="ds-label">Username</label>
            <div class="ds-input-wrap">
              <i class="bi bi-person ds-input-icon" aria-hidden="true"></i>
              <input
                id="username"
                type="text"
                name="username"
                [(ngModel)]="loginObj.Username"
                placeholder="your.username"
                class="ds-input"
                autocomplete="username"
                required>
            </div>
          </div>

          <!-- Password -->
          <div class="ds-field">
            <div class="ds-field-label-row">
              <label for="password" class="ds-label ds-label--inline">Password</label>
              <a class="ds-forgot-link" tabindex="-1" aria-label="Forgot password (not yet available)">Forgot?</a>
            </div>
            <div class="ds-input-wrap">
              <i class="bi bi-lock ds-input-icon" aria-hidden="true"></i>
              <input
                id="password"
                [type]="showPassword() ? 'text' : 'password'"
                name="password"
                [(ngModel)]="loginObj.Password"
                placeholder="••••••••"
                class="ds-input ds-input--password"
                autocomplete="current-password"
                required>
              <button
                type="button"
                class="ds-pw-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
                <i [class]="showPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <!-- Submit -->
          <button
            type="submit"
            class="ds-login-btn"
            [disabled]="isLoggingIn()">
            @if (isLoggingIn()) {
              <span class="ds-login-spinner" aria-hidden="true"></span>
              Signing in&hellip;
            } @else {
              Sign in
            }
          </button>

        </form>

      </div>

      <!-- Card footer strip -->
      <div class="ds-login-card-footer">
        <span>v{{ versionString }}</span>
        <span class="ds-login-footer-secure">
          <i class="bi bi-shield-check" aria-hidden="true"></i>
          Encrypted session
        </span>
      </div>

    </div>

    <!-- Below-card note -->
    <p class="ds-login-below">
      Theme preference is managed in
      <span class="ds-login-below-em">User Preferences</span> after sign&#8209;in.
    </p>

  </div>
</div>
